import { get, findKey, find } from 'lodash';

export const getCommunitiesContext = state => state.communitiesContext;

export const getApplicationConfig = (state, appDefinitionId) => get(getCommunitiesContext(state), appDefinitionId, {});

export const getAppDefinitionIdByPageUrl = (state, url) =>
  findKey(getCommunitiesContext(state), ({ sectionUrl }) => url.indexOf(sectionUrl) === 0);

export const getSectionUrlByPageUrl = (state, url) =>
  get(find(getCommunitiesContext(state), ({ sectionUrl }) => url.indexOf(sectionUrl) === 0), 'sectionUrl');



// WEBPACK FOOTER //
// ./app/selectors/communities-context-selectors.js